export default __webpack_public_path__ + "static/media/werewolfwake.7b68a9af.mp3";